module.exports = __webpack_public_path__ + "static/img/categories5.00e20c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories5.png
// module id = vsNf
// module chunks = 1